<template>
    <div class="read-body">
        <div class="read-top">
            <readback :msg="bookname" :goto="go.goDetail" :goparam="book_id"></readback>
        </div>
        <div class="add-book" v-if="info.is_favs==0">
            <div class="add-font">{{$t("addShelfTip")}}</div>
            <div class="add-btn" @click="favs(book_id)">{{$t("addShelf")}}</div>
        </div>
        <!--章节内容区域-->
        <div class="chapter-area" :style="{'background':backColor,'color':fontColor}">
            <div class="chapter-title">{{info.title}}</div>
            <!--设置区域-->
            <div class="select-area">
                <div class="color-area">
                    <div v-for="(item,index) in colorArr" :key="index" class="color-item" :style="{'background':item.color}" @click="changeBack(item,index)">
                        <div class="select-color" v-show="item.status">
                            <img v-if="index == 0" src="../assets/imgs/color1.png" alt="">
                            <img v-else-if="index == 1" src="../assets/imgs/color2.png" alt="">
                            <img v-else-if="index == 2" src="../assets/imgs/color3.png" alt="">
                            <img v-else-if="index == 3" src="../assets/imgs/color4.png" alt="">
                            <img v-else-if="index == 4" src="../assets/imgs/color5.png" alt="">
                            <img v-else src="../assets/imgs/color6.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="size-area">
                    <div class="down-size" @click="downSize">
                        <img  src="../assets/imgs/down-size.png" alt="">
                    </div>
                    <div class="font-size">{{size}}</div>
                    <div class="up-size" @click="addSize">
                        <img src="../assets/imgs/up-size.png" alt="">
                    </div>
                </div>
            </div>
            <div class="book-tip">
              ------ {{$t("balancetip")}} ------
            </div>
            <div class="book_balance">
                {{$t("price")}}：{{info.item_coin}}{{$t("coin")}}<br/>
                &nbsp;&nbsp;&nbsp;&nbsp; {{$t("balance")}}：{{user.score}}{{$t("coin")}}<br/>
            </div>
            <div class="pay-btn" @click="go.goPay(info.title, info.coin, info.book_id)">{{$t("充值并订阅")}}</div>

            <div class="btn-area">
                <div :class="[info.up_id>0 ? 'up-page' : 'up-page gray' ]" @click="preChapger">{{$t("preChapter")}}</div>
                <div class="cai-dan" @click="showMenu">{{$t("menu")}}</div>
                <div :class="[info.next_id>0 ? 'down-page' : 'down-page gray']" @click="nextChapter">{{$t("nextChapter")}}</div>
            </div>
            <!--下载APP-->
            <div class="load-app">
                <div class="load-btn" @click="go.downloadApp">{{$t("clickDownload")}}</div>
            </div>
        </div>
        <!--{{$t("menu")}}容器-->
        <div class="menu-body" v-show="menuFlag">
            <div class="menu-item" v-if="info.is_favs==0" @click="favs(info.book_id)">{{$t("addShelf")}}</div>
            <div class="menu-item" v-if="info.is_favs==1" @click="favs(info.book_id)">{{$t("delShelf")}}</div>
            <div class="menu-item" @click="go.goItemList(info.book_id)">{{$t("chapters")}}</div>
            <div class="menu-item" @click="go.goCmt(info.book_id)">{{$t("cmtList")}}</div>
            <div class="menu-item" @click="go.goDetail(info.book_id)">{{$t("detail")}}</div>
            <div class="menu-item" @click="go.backIndex()">{{$t("home")}}</div>
            <div class="menu-destory" @click="cancelMenu">{{$t("cancle")}}</div>
        </div>

        <div class="gift" @click="go.downloadApp()">
          <img src="../assets/imgs/gift.png" alt=""/>
        </div>
        <!--底部组件-->
        <pagebottom></pagebottom>
    </div>
</template>

<script>
import readback from "@/components/common/readback";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "readpay",
  components: {
    pagebottom,
    readback
  },
  data() {
    return {
      settings: {
        colorIndex: 0,
        fontSize: 35
      },
      //书籍名称
      bookname: this.$route.query.bookname,
      //字体大小
      size: 35,
      //背景色
      colorArr: [
        {
          color: "#ffffff",
          status: true,
          img: "../assets/imgs/color1.png",
          fontcolor: "#000000"
        },
        {
          color: "#f6e4c7",
          status: false,
          img: "../assets/imgs/color2.png",
          fontcolor: "#000000"
        },
        {
          color: "#f9e6e8",
          status: false,
          img: "../assets/imgs/color3.png",
          fontcolor: "#000000"
        },
        {
          color: "#dae8e3",
          status: false,
          img: "../assets/imgs/color4.png",
          fontcolor: "#000000"
        },
        {
          color: "#887579",
          status: false,
          img: "../assets/imgs/color5.png",
          fontcolor: "#000000"
        },
        {
          color: "#27384c",
          status: false,
          img: "../assets/imgs/color6.png",
          fontcolor: "#000000"
        }
      ],
      backColor: "#ffffff",
      fontColor: "#000000",
      //{{$t("menu")}}开关
      menuFlag: false,
      itemId: this.$route.query.itemId,
      book_id: this.$route.query.id,
      title: this.$route.query.title,
      coin: this.$route.query.coin,
      info: {},
      user:{}
    };
  },
  mounted: function() {

    var data = { path: "/read", query: { id: this.itemId } }
		localStorage.setItem("loginBack", JSON.stringify(data));

    this.getBookItem(this.itemId);
    this.getUser();
  },
  methods: {
    getUser: function() {
      this.req.getUser().then(res => {
        if (res.data.id > 0) {
          this.user = res.data;
        } else {
          this.go.goLogin();
        }
      });
    },
    //改变字体大小
    addSize() {
      this.size++;
      localStorage.setItem("read_font_size", this.size);
    },
    downSize() {
      if (this.size == 24) return;
      this.size--;
      localStorage.setItem("read_font_size", this.size);
    },
    //{{$t("preChapter")}}
    preChapger() {
      if (this.info.up_id > 0) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.go.goRead(this.info.up_id);
        this.getBookItem(this.info.up_id);
      }
    },
    //{{$t("nextChapter")}}
    nextChapter() {
      if (this.info.next_id > 0) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        this.go.goRead(this.info.next_id);
        this.getBookItem(this.info.next_id);
      } else {
        //todo
      }
    },
    //改变背景
    changeBack(obj, num) {
      let current = num;
      let colorArr = this.colorArr;
      colorArr.map((item, index) => {
        if (index == current) {
          item.status = true;
          localStorage.setItem("read_color_index", index);
        } else {
          item.status = false;
        }
      });
      this.backColor = obj.color;
    },
    //关闭{{$t("menu")}}
    cancelMenu() {
      this.menuFlag = false;
    },
    //打开{{$t("menu")}}
    showMenu() {
      this.menuFlag = true;
    },
    /**
     * 获取章节详情
     */
    getBookItem(id) {
      this.itemId = id;
      this.bookname = localStorage.getItem("bookName");
      this.req.bookItem(id).then(res => {
        if (res.status == 1) {
          this.info = res.data.info;
        }
      });
    },
    favs(id) {
      this.req.favs(id).then(res => {
        if (res) {
          this.$toast({
            message: res.result,
            duration: 3000
          });
          this.info.is_favs = this.info.is_favs == 1 ? 0 : 1;
        }
        this.cancelMenu();
      });
    }
  }
};
</script>

<style scoped>
.read-body {
  width: 100%;
  height: auto;
  padding-top: 1.01rem;
}
.read-top {
  width: 100%;
  height: auto;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}

/*加入书架*/
.add-book {
  width: 100%;
  height: 0.7rem;
  background: #ff1f4f;
  padding: 0 0.4rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-font {
  font-size: 0.3rem;
  color: #ffffff;
  line-height: 0.3rem;
}
.add-btn {
  width: 1.52rem;
  height: 0.42rem;
  border: 0.02rem solid #ffffff;
  border-radius: 0.06rem;
  font-size: 0.26rem;
  color: #ffffff;
  line-height: 0.42rem;
  text-align: center;
}
.chapter-title {
  padding: 0.42rem 0 0.45rem;
  font-size: 0.3rem;
  text-align: center;
  font-weight: 700;
}
/*设置区域*/
.select-area {
  width: 100%;
  padding: 0 0.3rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.size-area {
  display: flex;
  align-items: center;
}
.down-size,
.up-size {
  width: 0.52rem;
  height: 0.52rem;
  background: #e6e6e6;
  border-radius: 0.04rem;
  box-sizing: border-box;
  padding: 0.16rem 0 0 0;
}
.down-size img {
  display: block;
  width: 0.24rem;
  height: 0.2rem;
  margin: 0 auto;
}
.up-size img {
  display: block;
  width: 0.24rem;
  height: 0.2rem;
  margin: 0 auto;
}
.font-size {
  font-size: 0.24rem;
  line-height: 0.24rem;
  padding: 0 0.42rem;
  font-weight: 700;
}
/*内容*/
.book-con {
  width: 100%;
  padding: 0.78rem 0.3rem 0;
  box-sizing: border-box;
}
.con-area {
  width: 100%;
  height: auto;
  padding-bottom: 0.7rem;
  border-bottom: 0.02rem solid #ff1f4f;
  font-weight: 500;
  color: rgb(102, 102, 102);
}
/*按钮区域*/
.btn-area {
  width: 100%;
  height: auto;
  padding: 0.6rem 0.3rem 0.2rem;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.up-page,
.down-page {
  width: 1.4rem;
  height: 0.62rem;
  border: 0.01rem solid #4d4d4d;
  box-sizing: border-box;
  font-size: 0.28rem;
  line-height: 0.62rem;
  color: #ff1f4f;
  border-radius: 0.08rem;
  text-align: center;
}
.gray {
  color: gray;
}
.cai-dan {
  width: 2.9rem;
  height: 0.62rem;
  border: 0.01rem solid #4d4d4d;
  box-sizing: border-box;
  font-size: 0.28rem;
  line-height: 0.62rem;
  color: #ff1f4f;
  border-radius: 0.08rem;
  text-align: center;
}
.color-area {
  display: flex;
  align-items: center;
}
.color-item {
  width: 0.52rem;
  height: 0.52rem;
  border-radius: 0.04rem;
  margin-right: 0.2rem;
  position: relative;
}
.select-color {
  width: 0.52rem;
  height: 0.52rem;
  position: absolute;
  left: 0;
  top: 0;
}
.select-color img {
  display: block;
  width: 0.52rem;
  height: 0.52rem;
}
/*{{$t("menu")}}容器*/
.menu-body {
  width: 100%;
  background: #e6e6e6;
  position: fixed;
  left: 0;
  border-top: 1px solid #e6e6e6;
  bottom: 0rem;
  animation: show 0.8s;
}
.menu-item {
  width: 100%;
  height: 0.76rem;
  background: #ffffff;
  text-align: center;
  line-height: 0.76rem;
  margin-bottom: 0.02rem;
  font-size: 0.3rem;
}
.menu-destory {
  width: 100%;
  height: 0.76rem;
  text-align: center;
  line-height: 0.76rem;
  font-size: 0.3rem;
  background: #ffffff;
  left: 0;
  margin-top: 0.2em;
  bottom: 0;
}
/*下拉展示动画*/
@keyframes show {
  from {
    height: 0;
  }
  to {
    height: 4.7rem;
  }
}
/*下载APP*/
.load-app {
  width: 100%;
  height: auto;
  padding-bottom: 0.56rem;
  padding-top: 0.2rem;
}
.load-btn {
  width: 6rem;
  height: 0.68rem;
  margin: 0 auto;
  color: #fff;
  font-size: 0.26rem;
  line-height: 0.68rem;
  text-align: center;
  background: #ff1f4f;
  border-radius: 0.68rem;
}
.gift {
  position: fixed;
  width: 50px;
  height: 50px;
  right: 10px;
  top: 180px;
}
.gift img {
  width: 38px;
}
.book-tip {
  color: gray;
  text-align: center;
  font-size: 0.1rem;
  margin: 1.5rem 0 0.4rem 0;
}
.book_balance {
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.6rem;
  font-weight: bold;
}
.pay-btn {
  width: 6rem;
  height: 0.68rem;
  margin: 0.5rem auto 1rem;
  color: #fff;
  font-size: 0.26rem;
  line-height: 0.68rem;
  text-align: center;
  background: #ff1f4f;
}
</style>


// WEBPACK FOOTER //
// src/components/readpay.vue